export function pluralizeWorkplace(count: number, includeCount = true): string {
  return `${includeCount ? `${count} ` : ""}${count === 1 ? "workplace" : "workplaces"}`;
}
